/* eslint import/no-extraneous-dependencies: off */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const setDevToUserData = createAsyncThunk('devToUserData/setDevToUserData', async (inputData) => {
  let assignDevice = [];
  if (inputData === null) {
    return null
  }
  assignDevice = inputData.json;
  assignDevice = assignDevice.map(opsumDataObj => ({
    ...opsumDataObj,
    DeviceSerialHex: Number(opsumDataObj?.DeviceSerial)?.toString(16)?.toLocaleUpperCase()
  }));

  if (inputData.newSearchText && inputData.newSearchText.length > 0 && assignDevice && assignDevice.length > 0) {
    const searchText = inputData.newSearchText.toLowerCase();
    return assignDevice.filter((item) =>
      Object.values(item).some((value) =>
        String(value).toLowerCase()?.includes(searchText)
      )
    );

  }
  return assignDevice;
});

const initialState = null


const devToUser = createSlice({
  name: 'devToUser',
  initialState,
  reducers: {

  },
  extraReducers: (builder) => {
    builder.addCase(setDevToUserData.fulfilled, (state, action) => action.payload);
  },
});

export const selectDevToUser = ({ devToUser }) => devToUser;

export default devToUser.reducer;
